export enum LookupType{
    LookupAddon = "Lookups",
    Definition = "Definitions",
    Applicant = "Applicants",
    User = "Users",
    JobRole = "JobRoles",
}

export enum DefinitionLookupVisibility{
  MainForm = 'MainForm',
  ApplicationsTab = 'ApplicationsTab'
}
